import { useEffect, useState } from "react";
import api from "../api/axios.tsx";

type Friend = {
  user_name: string;
  first_name: string;
  email: string;
  id: string;
};

type FriendMap = Friend[];

export const useFriendsList = () => {
  const [friendsList, setFriendsList] = useState<FriendMap>([]);
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const userId = user?.id || ""; // Fallback to "default" if no user

  useEffect(() => {
    api
      .get("/friendships/list")
      .then((response) => {
        const fetchedFriendsList = response.data;
        setFriendsList(fetchedFriendsList);
      })
      .catch((error) => {
        console.error("Failed to fetch friends list:", error);
      });
  }, [userId]);

  return {
    friendsList,
  };
};
